import { type LegendComponentOption } from "echarts";

import { type ChartSeriesRecord } from "../../useChartsSeries";

const AVERAGE_CHAR_WIDTH_PX = 7;
const DEFAULT_LEGEND_WIDTH = 1000;
const DEFAULT_ITEM_GAP = 35;
const DEFAULT_PAGE_ICON_SIZE = 17;

export const shouldLegendWrap = (isCustomMode: boolean, allSeries: ChartSeriesRecord[]): boolean => {
  if (isCustomMode) {
    return false;
  }

  const estimatedLegendWidth = allSeries?.reduce<number>((acc, item, currentIndex) => {
    let res = 0;
    if (item?.name) {
      res = item.name.length * AVERAGE_CHAR_WIDTH_PX;
      if (currentIndex !== allSeries.length - 1) {
        res += DEFAULT_ITEM_GAP + DEFAULT_PAGE_ICON_SIZE;
      }
    }
    return acc + res;
  }, 0);

  return estimatedLegendWidth > DEFAULT_LEGEND_WIDTH;
};

export const getLegendConfig = (
  isCustomMode: boolean,
  fontColor: string,
  legendData: LegendComponentOption["data"],
  pageIconColor: string,
  isLegendWrapped: boolean
): LegendComponentOption | LegendComponentOption[] => {
  const commonLegendSettings: LegendComponentOption = {
    show: true,
    // @ts-expect-error
    animation: false,
    type: "scroll",
    data: legendData,
    pageIconColor,
    textStyle: {
      color: fontColor,
    },
    pageTextStyle: {
      color: fontColor,
    },
    itemWidth: 14,
  };

  const defaultLegend: LegendComponentOption = {
    ...commonLegendSettings,
    bottom: 0,
    width: DEFAULT_LEGEND_WIDTH,
    pageIconSize: DEFAULT_PAGE_ICON_SIZE,
    itemGap: DEFAULT_ITEM_GAP,
  };

  const extendedLegend: LegendComponentOption = {
    ...commonLegendSettings,
    // @ts-expect-error
    orient: "none", // workaround for multiline legend
    width: "100%",
    height: 50,
    itemGap: 20,
    pageIconSize: 15,
  };

  return isCustomMode || !isLegendWrapped
    ? defaultLegend
    : [
        {
          ...extendedLegend,
          bottom: 20,
          pageButtonGap: 0,
          pageIconSize: 0,
          pageButtonItemGap: 0,
          pageTextStyle: {
            fontSize: 1,
            color: "transparent",
          },
        },
        {
          ...extendedLegend,
          left: "auto",
          right: "50%",
          inactiveColor: "transparent",
          bottom: -20,
          itemStyle: {
            color: "transparent",
          },
          textStyle: {
            color: "transparent",
          },
          selectedMode: false,
        },
      ];
};
